import { Mapper } from './base-mapper';
import type { EwaKeyResultList, EwaSelectedStepKeyResult } from '@/types/ErgonomicWorkAnalysis';

export class GetSelectedStepKeyResultsMapper extends Mapper<EwaKeyResultList> {
	constructor(private readonly data: EwaSelectedStepKeyResult[]) {
		super();
	}

	toDomain(): EwaKeyResultList {
		const iteratedStepKeyIds = new Set<string>();
		const uniqueData = this.data.filter((item: EwaSelectedStepKeyResult) => {
			const isDuplicate = iteratedStepKeyIds.has(item.step_key_id);

			if (!isDuplicate) {
				iteratedStepKeyIds.add(item.step_key_id);
				return true;
			}

			return false;
		});

		return {
			raw_data: this.data,
			unique_data: uniqueData
		};
	}
}
